import * as R from "ramda";
import React, { Component } from "react";
import FlexView from "react-flexview";
import Container from "../../../modules/commons/Container";
import SimpleButton from "../../../modules/commons/SimpleButton";
import { defaultTableChange } from "../../../modules/custom/customTable";
import SimpleDataTable from "../../../modules/SimpleDataTable";
// import ManagementApprovalFilter from "./components/ManagementApprovalFilter";
import ManagementNRFSFilter from "./ManagementNRFSFilter";
import Api from "../../../Services/Api";
import {
  getValueFromDDL,
  mapToObjectDDL,
  removeNullFields,
} from "../../common/mapper";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import SimpleDDL from "../../../modules/SimpleDDL";
import SimpleDate from "../../../modules/SimpleDate";
import M from "moment/moment";
import { fetchDataAsync, getUserAccess } from "../../../Services/Utils";
import SimplePrintTable from "../../../modules/popup/SimplePrintTable";
import ErrorAction from "../../../Redux/ErrorRedux";
import { connect } from "react-redux";
import { HttpStatus } from "../../common/Constants";
import SimpleInput from "../../../modules/SimpleInput";
import Button from "../../../modules/commons/Button";
import SimpleAlert from "../../../modules/popup/SimpleAlert";

class ManagementNRFS extends Component {
  tableColumns = [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, tableMeta) => {
          const { page, rowsPerPage } = tableMeta.tableState;
          const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

          return <>{rowNumber}</>;
        },
        sort: false,
      },
    },
    {
      name: "kodeVarian",
      label: "Kode Varian",
      options: {
        customBodyRender: (val) => <p>{val}</p>,
        sort: false,
      },
    },
    {
      name: "kodeVarian",
      label: "Kode Varian",
      options: {
        customBodyRender: (val) => <p>{val}</p>,
        sort: false,
      },
    },
    {
      name: "namaVarian",
      label: "Nama Varian",
      options: {
        customBodyRender: (val) => <p>{val}</p>,
        sort: false,
      },
    },
    {
      name: "nomorRangka",
      label: "Nomor Rangka",
      options: {
        customBodyRender: (val) => <p>{val}</p>,
        sort: false,
      },
    },
    {
      name: "nomorMesin",
      label: "Nomor Mesin",
      options: {
        customBodyRender: (val) => <p>{val}</p>,
        sort: false,
      },
    },
    {
      name: "kodeWarna",
      label: "Kode Warna",
      options: {
        customBodyRender: (val) => <p>{val}</p>,
        sort: false,
      },
    },
    {
      name: "namaWarna",
      label: "Nama Warna",
      options: {
        customBodyRender: (val) => <p>{val}</p>,
        sort: false,
      },
    },
    {
      name: "tahunProduksi",
      label: "Tahun Produksi",
      options: {
        customBodyRender: (val) => <p>{val}</p>,
        sort: false,
      },
    },
    {
      name: "locator",
      label: "Locator",
      options: {
        customBodyRender: (val) => <p>{val}</p>,
        sort: false,
      },
    },
    {
      name: "statusRFS",
      label: "Status",
      options: {
        customBodyRender: (val, tableMeta) => {
          const rowData = tableMeta.rowData;
          const rowIndex = tableMeta.rowIndex;
          const isRFS = val === "RFS";

          return (
            <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
              <span>NRFS</span>
              <div
                onClick={() => this.handleChangeStatusAlertVisibility(rowData)}
                style={{
                  width: "40px",
                  height: "20px",
                  borderRadius: "20px",
                  backgroundColor: isRFS ? "green" : "red",
                  position: "relative",
                  cursor: "pointer",
                }}
              >
                <div
                  style={{
                    width: "16px",
                    height: "16px",
                    borderRadius: "50%",
                    background: "white",
                    position: "absolute",
                    top: "2px",
                    left: isRFS ? "22px" : "2px",
                    transition: "all 0.3s",
                  }}
                />
              </div>
              <span>RFS</span>
            </div>
          );
        },
      },
    },
  ];

  constructor(props) {
    super(props);
    this.initialFilter = {
      nomorRangka: null,
      nomorMesin: null,
      kodeVarian: null,
      kodeWarna: null,
      tahunProduksi: null,
      kodeLocator: null,
      statusRFS: null,
    };
    this.initialSearch = {
      nomorRangka: null,
      nomorMesin: null,
    };
    this.state = {
      loading: false,
      filterVisible: false,
      changeStatusAlertVisible: false,
      successAlertVisible: false,
      deleteAction: false,
      userAccess: null,
      selectedData: null,
      selectedCabang: null,
      rowData: null,
      filterData: this.initialFilter,
      search: this.initialSearch,
      submittedFilterData: {},
      dataTable: [],
      dataCabang: [],
      searchData: {},
      searchOptions: [
        {
          label: "Nomor Rangka",
          value: "Nomor Rangka",
        },
        {
          label: "Nomor Mesin",
          value: "Nomor Mesin",
        },
      ],
      pagination: {
        count: 0,
        limit: 5,
        page: 1,
        orderBy: "id",
        sort: "ASC",
      },
    };
  }

  handleChangeStatusAlertVisibility = (data) => {
    this.setState((prevState) => ({
      ...prevState,
      changeStatusAlertVisible: !prevState.changeStatusAlertVisible,
      rowData: data,
    }));
  };

  handleToggle = async (selectedData) => {
    let request = {
      nomorMesin: selectedData[5],
      statusRFS: selectedData[10] == "RFS" ? "NRFS" : "RFS",
    };

    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").updateNRFSUnit,
      menuName: "Management NRFS",
      setError: this.props.setError,
      args: request,
    });

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prevState) => ({
        ...prevState,
        changeStatusAlertVisible: !prevState.changeStatusAlertVisible,
      }));
      this.handleSuccessAlertVisibility();
    }
  };

  handleSuccessAlertVisibility = () => {
      this.setState((prevState) => ({
        ...prevState,
        successAlertVisible: !prevState.successAlertVisible,
      }));
    };

    handleSuccess = async () => {
    const { page, limit } = this.state.pagination;
    const { submittedFilterData } = this.state;

    this.setState((prevState) => ({
      ...prevState,
      successAlertVisible: !prevState.successAlertVisible,
    }));

    await this.fetchData(
      {
        kodeCabang: this.state.selectedCabang?.value,
        ...submittedFilterData,
      },
      page,
      limit
    );
  };


  componentDidMount = async () => {
    this.handleTriggerLoading();
    await this.fetchDataCabang();
    this.handleTriggerLoading();
  };

  componentDidUpdate = async (prevProps, prevState) => {
    if (!R.equals(this.state.selectedCabang, prevState.selectedCabang)) {
      this.handleTriggerLoading();
      await this.refetch();
      this.setState((prevState) => ({
        ...prevState,
        userAccess: getUserAccess(
          this.props.menuAccess,
          this.state.selectedCabang?.value
        ),
      }));

      this.handleTriggerLoading();
    }
  };

  handleModalFilterVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterVisible: !prevValue.filterVisible,
    }));
  };

  handleStateChange = (val) => {
    this.setState(val);
  };

  handleSubmitFilter = async () => {
    this.handleTriggerLoading();
    let requestBody = {
      ...removeNullFields(this.parseFilterData(this.state.filterData)),
    };
    this.handleClearSearch({
      nomorRangka: null,
      nomorMesin: null,
    });
    this.handleChangeSubmittedFilterData(requestBody);

    await this.fetchData(requestBody, 1, 5);
    this.handleTriggerLoading();
    this.handleModalFilterVisibility();
  };

  handleValueChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
        [name]: value,
      },
    }));
  };

  handleValueChangeSearch = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      selectedCabang: value,
    }));
  };

  handleSearch = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterData: {},
    }));
    let fieldName = "nomorMesin";
    if (this.state.searchData?.key?.value === "Nomor Rangka") {
      fieldName = "nomorRangka";
    }

    // this.handleResetPagination();

    this.fetchData({
      [fieldName]: this.state.searchData?.value || "",
    });
  };

  handleResetSearch = async () => {
  this.setState((prevValue) => ({
    ...prevValue,
    searchData: {
      key: null,
      value: "",
    },
  }));

  await this.fetchData(
    removeNullFields(this.parseFilterData(this.state.search)),
    1,
    5
  );
};

  handleClearFilter = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterData: {
        ...prevValue.filterData,
        ...this.initialFilter,
      },
    }));
  };

  handleClearSearch = (value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      search: {
        ...prevValue.search,
        ...value,
      },
    }));
  };

  handleChangePage = async (tableState) => {
    this.handleTriggerLoading();
    let limit = tableState.rowsPerPage;
    let page = tableState.page + 1;
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: page,
        limit: limit,
      },
    }));
    let { submittedFilterData } = this.state;
    const requestBody = {
      kodeCabang: this.state.selectedCabang?.value,
      ...submittedFilterData,
    };

    await this.fetchData(requestBody, page, limit);
    this.handleTriggerLoading();
  };

  handleChangeRowsPerPage = async (tableState) => {
    this.handleTriggerLoading();
    let limit = tableState.rowsPerPage;
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        count: 1,
        page: 1,
        limit: limit,
      },
    }));
    let { submittedFilterData } = this.state;
    const requestBody = {
      kodeCabang: this.state.selectedCabang?.value,
      ...submittedFilterData,
    };

    await this.fetchData(requestBody, 1, limit);
    this.handleTriggerLoading();
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  refetch = async () => {
    const { page, limit } = this.state.pagination;
    const { submittedFilterData } = this.state;
    
    await this.fetchData(
      {
        kodeCabang: this.state.selectedCabang?.value,
        ...submittedFilterData,
      },
      page,
      limit
    );
  };


  fetchData = async (body = {}, page = 1, limit = 5) => {
    this.handleTriggerLoading();
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: { ...prevValue.pagination, count: 0 },
    }));
    let req = {
      ...body,
      kodeCabang: this.state.selectedCabang?.value,
      limit,
      page,
    };

    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getAllManagementNRFS,
      menuName: "Management NRFS",
      setError: this.props.setError,
      args: req,
    });

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prevValue) => ({
        ...prevValue,
        dataTable: res.data.data,
        pagination: {
          ...prevValue.pagination,
          count: res.data.totalData,
          limit,
          page,
        },
      }));
    }
    this.handleTriggerLoading();
  };

  fetchDataCabang = async () => {
    try {
      let res = await Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang();
      if (res.ok) {
        let filteredData = res.data.data.filter((item) =>
          this.props.menuAccess
            .map((data) => data.idRefObj)
            .includes(item.kodeCabang)
        );

        if (filteredData.length !== 0) {
          this.setState((prevValue) => ({
            ...prevValue,
            dataCabang: filteredData.map((item) =>
              mapToObjectDDL(item.namaDealer, item.kodeCabang)
            ),
            selectedCabang: mapToObjectDDL(
              filteredData[0].namaDealer,
              filteredData[0].kodeCabang
            ),
            search: {
              ...prevValue.search,
            },
          }));
        }
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  parseFilterData(data) {
    return {
      ...data,
      kodeCabang: getValueFromDDL(data, "kodeCabang"),
      kodeVarian: getValueFromDDL(data, "kodeVarian"),
      kodeWarna: getValueFromDDL(data, "kodeWarna"),
      kodeLocator: getValueFromDDL(data, "kodeLocator"),
      statusRFS: getValueFromDDL(data, "statusRFS"),
    };
  }

  handleChangeSubmittedFilterData = (data) => {
    this.setState((prevState) => ({
      ...prevState,
      submittedFilterData: data,
    }));
  };

  handleResetAllFilters = () => {
    this.setState((prevState) => ({
      ...prevState,
      filterData: this.initialFilter,
      search: this.initialSearch,
      submittedFilterData: {},
      pagination: { ...prevState.pagination, count: 0 },
    }));
  };

  handleResetPagination = () => {
    this.setState({
      pagination: {
        count: 0,
        limit: 5,
        page: 1,
        orderBy: "id",
        sort: "ASC",
      },
    });
  };

  render() {
    return (
      <>
        <Container>
          <SimpleDDL
            id="select_options_nama_cabang"
            box="search"
            name="kodeCabang"
            containerclassname="width width-250px"
            placeholder="Nama Cabang"
            menuPosition="fixed"
            options={this.state.dataCabang}
            value={this.state.selectedCabang}
            onChange={(value, { name }) =>
              this.handleValueChangeSearch(name, value)
            }
          />

          <FlexView
            vAlignContent="center"
            hAlignContent="right"
            className="margin-top-15px margin-bottom-15px"
          >
            <FlexView
              vAlignContent="center"
              hAlignContent="right"
              style={{ gap: "10px", marginRight: "20px" }}
            >
              <SimpleDDL
                id="select_options_code_name_varian"
                placeholder="Select NoKa/NoSin"
                box="search"
                containerclassname="margin-bottom-none width width-250px"
                isClearable
                options={this.state.searchOptions}
                value={this.state.searchData?.key || null}
                onChange={(value) =>
                  this.handleStateChange((prevValue) => ({
                    ...prevValue,
                    searchData: {
                      key:
                        typeof value === "string"
                          ? value?.toUpperCase()
                          : value,
                    },
                  }))
                }
              />
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <SimpleInput
                  placeholder="Input NoKa/NoSin"
                  containerclassname="margin-bottom-none"
                  readOnly={!this.state.searchData?.key}
                  value={this.state.searchData?.value}
                  onChange={({ target }) =>
                    this.handleStateChange((prevValue) => ({
                      ...prevValue,
                      searchData: {
                        ...prevValue.searchData,
                        value: target.value.toUpperCase(),
                      },
                    }))
                  }
                />
                <SimpleButton
                  category="action_button"
                  icon={
                    <i
                      className="fa fa-search"
                      style={{ fontSize: 20, color: "#e74c3c" }}
                    />
                  }
                  onClick={() => this.handleSearch()}
                />
                <SimpleButton
                  category="action_button"
                  icon={
                    <span
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                        color: "#e74c3c",
                      }}
                    >
                      X
                    </span>
                  }
                  onClick={this.handleResetSearch}
                />
              </div>
            </FlexView>
            <Button
              type="button"
              className="btn background-red"
              onClick={this.handleModalFilterVisibility}
            >
              <span>
                <i className="fa fa-qrcode"></i>
              </span>
            </Button>
          </FlexView>

          <SimpleDataTable
            data={this.state.dataTable}
            columns={this.tableColumns}
            toCount={this.state.pagination.count}
            rowsPerPage={this.state.pagination.limit}
            page={this.state.pagination.page - 1}
            options={defaultTableChange(
              (tableState) => this.handleChangePage(tableState),
              (tableState) => this.handleChangeRowsPerPage(tableState)
            )}
          />
        </Container>

        {this.state.changeStatusAlertVisible && (
          <SimpleAlert
            title={"Konfirmasi"}
            visible={this.state.changeStatusAlertVisible}
            onClickClose={this.handleChangeStatusAlertVisibility}
            content={
              <FlexView column hAlignContent={"left"}>
                <p>Status untuk </p>
                <p>No. Rangka: {this.state.rowData[4]}</p>
                <p>No. Mesin: {this.state.rowData[5]}</p>
                <br />
                <p>
                  dirubah menjadi{" "}
                  {this.state.rowData[10] === "RFS" ? "NRFS" : "RFS"}. Apakah
                  anda yakin?
                </p>
              </FlexView>
            }
            additionalButtons={
              <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                <SimpleButton
                  onClick={() => this.handleToggle(this.state.rowData)}
                >
                  Iya
                </SimpleButton>
                <SimpleButton onClick={this.handleChangeStatusAlertVisibility}>
                  Tolak
                </SimpleButton>
              </FlexView>
            }
          />
        )}

        {this.state.successAlertVisible && (
          <SimpleAlert
            visible={this.state.successAlertVisible}
            title={"Information"}
            content={"Perubahan status berhasil dilakukan"}
            onClickClose={this.handlesuccessAlertVisibility}
            additionalButtons={
              <SimpleButton
                type="button"
                text="OK"
                onClick={this.handleSuccess}
              />
            }
          />
        )}

        {this.state.filterVisible && (
          <ManagementNRFSFilter
            setError={this.props.setError}
            filterData={this.state.filterData}
            selectedCabang={this.state.selectedCabang}
            visible={this.state.filterVisible}
            onClickClose={this.handleModalFilterVisibility}
            onClearFilter={this.handleClearFilter}
            onValueChange={this.handleValueChange}
            onSubmit={this.handleSubmitFilter}
          />
        )}

        <SimpleLoadingOverlay active={this.state.loading} />
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    auth: state.auth,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ManagementNRFS);
